import { Grid, useTheme } from "@mui/material";
import NavigationBody from "./navigation-body";

const NavigationLayout = () => {
    return (
        <>
            <Grid 
                width='100%' 
                py={{xs: 2, md: 4}}
                position='fixed'
                zIndex={1000}
            >
                <NavigationBody />
            </Grid>
        </>
    );
}

export default NavigationLayout;